import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { combine } from 'effector'
import { model as gravyModel } from '~/features/payment/gravy'

export const $gravyTranslations = combine(i18n.$t, ({ t }) => ({
  backButtonTitle: t('back'),
  submitButtonTitle: t('confirm_payment'),
}))

register(gravyModel.$gravyPopupIsOpened, '$gravyPopupIsOpened')
register(gravyModel.$currentStepGravy, '$currentStepGravy')
register(gravyModel.$transactionFields, '$transactionFields')
register(gravyModel.$isReadyToSubmit, '$isReadyToSubmit')
register(gravyModel.$isPending, '$isPending')

register(gravyModel.onGravyRequestSended, 'onGravyRequestSended')
register(gravyModel.onOptionsLoadedRaw, 'onOptionsLoadedRaw')
register(gravyModel.onPaymentMethodSelectedRaw, 'onPaymentMethodSelectedRaw')
register(gravyModel.onArgumentErrorRaw, 'onArgumentErrorRaw')
register(gravyModel.onFormUpdateRaw, 'onFormUpdateRaw')
register(gravyModel.onTransactionCreatedRaw, 'onTransactionCreatedRaw')
register(gravyModel.onTransactionFailedRaw, 'onTransactionFailedRaw')
register(gravyModel.onTransactionCancelledRaw, 'onTransactionCancelledRaw')
register(gravyModel.onApiErrorRaw, 'onApiErrorRaw')
